import { render } from "./client-history-overview.vue?vue&type=template&id=454986a6&ts=true"
import script from "./client-history-overview.ts?vue&type=script&lang=ts&external"
export * from "./client-history-overview.ts?vue&type=script&lang=ts&external"

import "./../../generalizations/history-overview/history-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__